const monthMap = {
  'січня': 1,
  'лютого': 2,
  'березня': 3,
  'квітня': 4,
  'травня': 5,
  'червня': 6,
  'липня': 7,
  'серпня': 8,
  'вересня': 9,
  'жовтня': 10,
  'листопада': 11,
  'грудня': 12,
  'styczeń': 1,
  'luty': 2,
  'marzec': 3,
  'kwiecień': 4,
  'maj': 5,
  'czerwiec': 6,
  'lipiec': 7,
  'sierpień': 8,
  'wrzesień': 9,
  'październik': 10,
  'listopad': 11,
  'grudzień': 12
}

export const getIsoDateStr = (dateStr) => {
  const parts = dateStr.trim().split(/\s+/)

  const day = parts[0]
  const monthName = parts[1].toLowerCase()
  const year = parts[2]

  const month = monthMap[monthName.toLowerCase()] || 1

  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T00:00:00Z`
}
